<template>
  <div>
    <el-dialog
      top="10vh"
      width="700px"
      center
      :title="`${platformTypeName} ${
        enableDialogObj.platformType === 'qrcode'
          ? `「${enableDialogObj.id || ''}」历史纪录 `
          : `「${enableDialogObj.bankCardNumber || ''}」历史纪录 ( ${
              enableDialogObj.id || ''
            } ) `
      }`"
      :visible="enableDialogObj.visible"
      @close="HandleCancel()"
    >
      <el-table
        border
        stripe
        ref="table"
        v-loading="listLoading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        element-loading-spinner="el-icon-loading"
        :data="dataList"
      >
        <el-table-column label="时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createdTime }}
          </template>
        </el-table-column>
        <el-table-column label="错误描述">
          <template slot-scope="scope">
            {{ scope.row.errorDesc }}
          </template>
        </el-table-column>
        <el-table-column width="100" align="center" label="启用或禁用">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.userEnable === true"
              type="success"
              size="mini"
              >启用</el-tag
            >
            <el-tag
              v-else-if="scope.row.userEnable === false"
              type="danger"
              size="mini"
              >禁用</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column width="70" align="center" label="类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 0" type="primary" size="mini"
              >一般</el-tag
            >
            <el-tag v-else-if="scope.row.type === 1" type="danger" size="mini"
              >风控</el-tag
            >
            <el-tag v-else-if="scope.row.type === 2" type="warning" size="mini"
              >核查</el-tag
            >
            <el-tag v-else-if="scope.row.type === 3" type="info" size="mini"
              >异常</el-tag
            >
            <el-tag
              v-else-if="scope.row.type === 4"
              class="order-check-style"
              size="mini"
              >查单</el-tag
            >
            <el-tag
              v-else-if="scope.row.type === 5"
              class="agent-disabled-style"
              size="mini"
              >代禁</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作人员">
          <template slot-scope="scope">
            {{ scope.row.userName }}
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageQuery.pageNum"
        :limit.sync="pageQuery.pageSize"
        @pagination="getList()"
      />
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import Pagination from "@/views/components/Pagination";
import { bankCardEnableHistory } from "@/api/account";

export default {
  mixins: [mainCommon],
  props: ["enableDialogObj"],
  data() {
    return {
      platformTypeName: null, // 银行卡 or 二维码
      listLoading: false,
      dataList: [],
      total: 0,
      pageQuery: {
        pageSize: varCommon.pagination.pageSize,
        pageNum: 1,
      },
    };
  },
  components: {
    Pagination,
  },
  watch: {
    enableDialogObj(row) {
      if (row.visible) {
        if (row.platformType && row.platformType === "qrcode") {
          this.platformTypeName = "二维码";
        } else {
          this.platformTypeName = "银行卡";
        }
        this.getList();
      }
    },
  },
  methods: {
    HandleCancel() {
      this.$emit("update:enable-dialog-obj", {});
    },
    getList() {
      this.listLoading = true;
      bankCardEnableHistory(this.enableDialogObj.id, this.pageQuery)
        .then((res) => {
          this.dataList = res.data.list;
          this.total = res.data.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-check-style {
  color: #fff;
  background-color: #d6a6a6;
  border-color: #d6a6a6;
}
.agent-disabled-style {
  color: #fff;
  background-color: #000;
  border-color: #000;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/EnableDialog.vue